import { render, staticRenderFns } from "./new-provider.modal.vue?vue&type=template&id=9b4f2f14&scoped=true"
import script from "./new-provider.modal.vue?vue&type=script&lang=js"
export * from "./new-provider.modal.vue?vue&type=script&lang=js"
import style0 from "./new-provider.modal.vue?vue&type=style&index=0&id=9b4f2f14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4f2f14",
  null
  
)

export default component.exports